<div class="flex flex-col gap-(--gap-relaxed)">
  @if (!pageStore.isHistoryReady()) {
    <ces-list-skeleton [gap]="2" />
  }

  @if (pageStore.isHistoryReady() && hist.isLoading()) {
    <ces-loading-spinner context="inline" size="sm" [message]="'history.refreshing' | transloco" [vertical]="false" />
  }

  @if (pageStore.isHistoryReady() && !hist.isLoading() && !chronologicalHistory().length) {
    <div class="text-center text-(color:--text-secondary) italic py-(--space-8)">
      {{ 'history.noHistory' | transloco }}
    </div>
  }

  @if (t.testMode()) {
    <div class="bg-yellow-100 p-(--padding-card) mb-(--space-4) rounded-(--radius-md)">
      <h4>DEBUG INFO</h4>
      <p><strong>chronologicalHistory().length:</strong> {{ chronologicalHistory().length }}</p>
      <p><strong>historyService.campaignHistory().length:</strong> {{ hist.campaignHistory().length }}</p>
      <p><strong>pageStore.isHistoryReady():</strong> {{ pageStore.isHistoryReady() }}</p>
      <p><strong>hist.isLoading():</strong> {{ hist.isLoading() }}</p>
      <p><strong>currentCampaignId:</strong> {{ hist.currentCampaignId() }}</p>

      <p>
        <strong>Condition accordéon (doit être true):</strong>
        {{ pageStore.isHistoryReady() && !hist.isLoading() && chronologicalHistory().length > 0 }}
      </p>

      <details>
        <summary>Premier log (clic pour voir)</summary>
        <pre>{{ chronologicalHistory()[0] | json }}</pre>
      </details>

      <details>
        <summary>Tous les logs (clic pour voir)</summary>
        <pre>{{ chronologicalHistory() | json }}</pre>
      </details>
    </div>
  }

  @if (pageStore.isHistoryReady() && !hist.isLoading() && chronologicalHistory().length > 0) {
    <div class="flex justify-end mb-(--space-2)">
      <p-button
        [text]="true"
        size="small"
        [label]="
          openAccordions().length === chronologicalHistory().length
            ? ('history.collapseAll' | transloco)
            : ('history.expandAll' | transloco)
        "
        [icon]="openAccordions().length === chronologicalHistory().length ? 'pi pi-minus' : 'pi pi-plus'"
        (onClick)="toggleAllAccordions($event)" />
    </div>
    <p-accordion [multiple]="true" [value]="openAccordions()">
      @for (log of chronologicalHistory(); track log.id) {
        <p-accordionpanel [value]="log.id" class="group">
          <p-accordionheader
            class="gap-(--gap-normal) flex-row-reverse justify-end pb-(--space-3) group-[.p-accordionpanel-active]:pb-(--space-2) transition-all rounded-(--radius-md)">
            <div class="flex justify-between items-center w-full">
              <div class="flex items-center gap-(--gap-normal)">
                <div class="flex flex-col">
                  <span class="font-semibold pr-(--space-4) text-sm" [pTooltip]="getModificationTooltip(log)">{{
                    getLogTitle(log)
                  }}</span>
                </div>
              </div>
              <div class="text-right">
                <div class="flex gap-(--gap-tight) text-sm text-(color:--text-disabled) font-normal items-center">
                  @if (log.userId) {
                    <span>{{ getUserName(log.userId) }},</span>
                  }
                  <span
                    (dblclick)="toggleAllAccordions($event)"
                    class="select-none"
                    [pTooltip]="'history.doubleClickToToggle' | transloco"
                    tooltipPosition="top"
                    >{{ formatLogDate(log.date) }}</span
                  >
                  @if (t.testMode()) {
                    <ces-icon
                      class="cursor-pointer hover:text-red-300 text-(color:--text-disabled)"
                      size="sm"
                      containerSize="xs"
                      (click)="hist.logStore.deleteLog(log.id)"
                      >delete</ces-icon
                    >
                  }
                </div>
              </div>
            </div>
          </p-accordionheader>
          <p-accordioncontent>
            <ces-log-content [log]="log" />
          </p-accordioncontent>
        </p-accordionpanel>
      }
    </p-accordion>

    @if (t.testMode()) {
      <div class="mt-(--space-6) p-(--padding-card) bg-(--surface-1) rounded-(--radius-lg)">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-(--gap-relaxed) text-sm text-(color:--text-secondary)">
          <div>
            <strong>Total des actions :</strong><br />
            {{ chronologicalHistory().length }}
          </div>
          <div>
            <strong>Dernière activité :</strong><br />
            {{ getLastModificationDate() }}
          </div>
          <div>
            <strong>Total des modifications :</strong><br />
            {{ getTotalModificationCount() }}
          </div>
        </div>
      </div>
    }
  }
</div>
